module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL SaaS AWARD Summer 2024_営業担当の印象No.1-f7832f32f2d32a2df6db877c923ee33b.png";